import { render, staticRenderFns } from "./slide-preview.vue?vue&type=template&id=e8666b08&"
import script from "./slide-preview.vue?vue&type=script&lang=js&"
export * from "./slide-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports